module.exports = {"env":"production","apiUrl":"https://apiweb.globalbridgeconnections.com.pe"};